import React, { useEffect, useContext } from "react";
import { StoreContext } from "../../Context/StoreContext";
import Carousel from "react-multi-carousel";
import Previous from "../../VibehutUI/Icons/Previous";
import Next from "../../VibehutUI/Icons/Next";
import { useState } from "react";
import { getAutoOrganizedEvents } from "../../services/eventService";
import EventCard from "../../VibehutUI/Card/EventCard";

interface Props {
  sliderWidth: number;
}

function HomeAutoOrganizedEvents({ sliderWidth }: Props) {
  const { state } = useContext(StoreContext);
  const [events, setEvents] = useState([]);
  const { auth } = state;
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 3000, min: 769 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 768, min: 641 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };

  const getAutoOrganizedEventsFun = async () => {
    await getAutoOrganizedEvents(auth?.user?.token)
      .then((res) => {
        setEvents(res.data);
      })
      .catch((err) => {
        setEvents([]);
        console.log("err", err);
      });
  };
  useEffect(() => {
    getAutoOrganizedEventsFun();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function splitArrayIntoChunks(chunkSize = 2) {
    const result = [];
    for (let i = 0; i < events.length; i += chunkSize) {
      result.push(events.slice(i, i + chunkSize));
    }
    return result;
  }

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;
    return events?.length > 3 ? (
      <div className="absolute right-1 md:top-12 top-8">
        <span className="flex space-x-3">
          <span onClick={() => previous()} className="cursor-pointer">
            <Previous disabled={currentSlide === 0} />
          </span>

          <span onClick={() => next()} className="cursor-pointer">
            <Next />
          </span>
        </span>
      </div>
    ) : (
      <></>
    );
  };
  const chunkEvents = splitArrayIntoChunks();
  return (
    <>
      {events?.length > 0 && (
        <div className="relative" style={{ width: sliderWidth }}>
          <div className="pt-8">
            <div className="px-2">
              <p className="font-bold md:text-2xl text-xl text-darkNight dark:text-frescoWhite">
                Auto Organized Events
              </p>
              <p className="text-lg text-darkGray">
                Events were automatically created when certain individuals made
                requests.
              </p>
            </div>

            <div className="pt-7 ">
              <div className="hidden md:block">
                <Carousel
                  responsive={responsive}
                  renderButtonGroupOutside
                  itemClass="px-2.5"
                  arrows={false}
                  shouldResetAutoplay={false}
                  customButtonGroup={<ButtonGroup />}
                >
                  {events.map((event) => (
                    <EventCard
                      event={event}
                      key={event?._id}
                      showRoomLink
                      enableTopMargin={false}
                      showCreated
                      showEventTimeLine
                    />
                  ))}
                </Carousel>
              </div>
              <div className="md:hidden flex flex-col gap-4">
                <Carousel
                  responsive={responsive}
                  renderButtonGroupOutside
                  itemClass="px-2.5"
                  arrows={false}
                  shouldResetAutoplay={false}
                  customButtonGroup={<ButtonGroup />}
                >
                  {chunkEvents.map((eventArray, rowIndex) => (
                    <div key={rowIndex} className="flex flex-col gap-4">
                      {eventArray.map((item) => {
                        return (
                          <EventCard
                            event={item}
                            key={item?._id}
                            showRoomLink
                            enableTopMargin={false}
                            showCreated
                            showEventTimeLine
                          />
                        );
                      })}
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default HomeAutoOrganizedEvents;
